import React from 'react';
import styled from 'styled-components';
import Column from 'gatsby-theme-pagebuilder/src/components/column/index';
import Previews from 'gatsby-theme-vehicles/src/sections/previews';
import Button from 'gatsby-theme-pagebuilder/src/components/button/index';
import Content from 'gatsby-theme-pagebuilder/src/components/content';

const StyledContent = styled(Content)`
  width: 100%;
  margin-bottom: 0.5rem;
`;

const PreviewsTitle = styled.div`
  width: 100%;
  text-align: left;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.sm}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  h1 {
    margin: 0;
  }
`;

const PagebuilderBlockVehicles = ({
  columnWidth,
  align,
  justify,
  order,
  title,
  offset,
  vehicles = [],
  numberOfItems = 4,
  button,
  vehicleDetailPage,
}) => (
  <Column
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    order={order}
    offset={offset}
  >
    <StyledContent textAlign={justify}>
      <PreviewsTitle>
        <h1>{title}</h1>
        {button && <Button {...button} />}
      </PreviewsTitle>
    </StyledContent>
    <Previews
      layout="column"
      breakpoint={992}
      vehicles={vehicles}
      limit={numberOfItems}
      vdp={vehicleDetailPage}
    />
  </Column>
);

export default styled(PagebuilderBlockVehicles)``;
